export default {
  MOANK_LOAN: 'moank-loan',
  MOANK_LOAN_HIGH_FEE: 'moank-loan-high-fee',
  CREDIT_LINE: 'account-credit',
  INSURANCE_LOAN_PROTECTION: 'insurance-loan-protection',
};
